import {
  Georeference,
  GeoreferenceCoordinate,
  GeoreferenceDataType,
} from 'apollo/schema/types';
import { DrawMode } from 'hooks/useTerraDraw';

export function toLatLng(coords: GeoreferenceCoordinate) {
  return new google.maps.LatLng(
    parseFloat(coords.latitude),
    parseFloat(coords.longitude),
  );
}

export const markerTypes: GeoreferenceDataType[] = ['POINT', 'CENTER'];
export const polygonTypes: GeoreferenceDataType[] = ['POLYGON', 'OUTLINE'];
export const polylineTypes: GeoreferenceDataType[] = ['POLYLINE'];

export const isMarkerType = (t: GeoreferenceDataType) =>
  markerTypes.includes(t);
export const isPolygonType = (t: GeoreferenceDataType) =>
  polygonTypes.includes(t);
export const isPolylineType = (t: GeoreferenceDataType) =>
  polylineTypes.includes(t);

/** Maps a georeference data type to the TerraDraw mode used to draw it. */
export function getDrawMode(
  dataType: GeoreferenceDataType | null,
): DrawMode | null {
  if (!dataType) return null;
  if (isMarkerType(dataType)) return 'point';
  if (isPolygonType(dataType)) return 'polygon';
  if (isPolylineType(dataType)) return 'linestring';
  return null;
}

export function createBounds(georefs: Georeference[]) {
  const bounds = new google.maps.LatLngBounds();

  georefs.forEach(georef => {
    georef.data.coordinates.forEach(coords => bounds.extend(toLatLng(coords)));
  });

  if (!georefs.length) {
    bounds.extend(new google.maps.LatLng(-50, -50));
    bounds.extend(new google.maps.LatLng(50, 50));
  }

  return bounds;
}
